import React, { useState, useEffect, useCallback, useRef } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { BsSearch } from "react-icons/bs";
import { API_URL } from "../../config";
import { jwtDecode } from 'jwt-decode';
import { logAuditUI } from "../../utils/auditLogger";

function DashboardCard21() {

  const navigate = useNavigate();
  const [userData, setUserData] = useState([]);
  const [filteruserData, setfilterUserData] = useState([]);
  const [specData, setspecData] = useState([]);
  const [userinstData, setUserinstData] = useState([]);
  const [Adress, setAdress] = useState([]);
  const [Adressinst, setAdressinst] = useState([]);
  const [searchQuery1, setSearchQuery1] = useState('');
  const itemsPerPage = 100;
  const [currentPage, setCurrentPage] = useState(1);
  const [showGrid, setShowGrid] = useState(true);
  const [selectedInstitutionId, setSelectedInstitutionId] = useState(null);
  const [debouncedSearch, setDebouncedSearch] = useState(searchQuery1);
  const getJwtFromCookies = () => {
    const cookies = document.cookie.split("; ");
    const tokenCookie = cookies.find(row => row.startsWith("accessToken="));
    return tokenCookie ? tokenCookie.split("=")[1] : null;
  };
  //const token = getJwtFromCookies();

  const token = localStorage.getItem('jwtToken');

  const [user, setUser] = useState(null);

  useEffect(() => {
    logAuditUI({
      actionType: 'VIEW_LIST',
      module: 'Doctori',
      description: 'A accesat lista de doctori',
      routePath: '/physicians',
    });
  }, []);

  useEffect(() => {
    if (token) {
      try {
        const decoded = jwtDecode(token);
        setUser(decoded);
        //console.log(decoded)
      } catch (error) {
        console.error('Error decoding the token:', error);
      }
    }
  }, [token]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowGrid(false); // După 1 secundă, comutăm pe grid
    }, 1000);

    // Cleanup pentru timer
    return () => clearTimeout(timer);
  }, []);

  const fetchData = () => {
    axios
      .get(`${API_URL}/api/physician1?page=${currentPage}&itemsPerPage=${itemsPerPage}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        // ////////////////////////console.log(response.data)
        setfilterUserData(response.data);
      })
      .catch((error) => {
        console.error("Error fetching manage data:", error);
      });
  };

  const fetchSearchData = (term, page) => {
    // ////////////////////////console.log(`Fetching search data for term: ${term}, page: ${page}`); // Debugging line
    axios
      .get(`${API_URL}/api/physiciansinstitutedetalii?search=${term}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {

        setfilterUserData(response.data);
      })
      .catch((error) => {
        console.error("Error fetching search data:", error);
      });
  };

  useEffect(() => {
    axios
      .get(`${API_URL}/api/physician`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setUserData(response.data);
        fetchData();
      })
      .catch((error) => {
        console.error("Error fetching user data:", error);

      });
  }, []);

  useEffect(() => {
    axios
      .get(`${API_URL}/api/speciality`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setspecData(response.data)
        //////////////////////////////console.log(response.data)
      })
      .catch((error) => {
        console.error("Error fetching user data:", error);

      });
  }, []);

  useEffect(() => {
    axios
      .get(`${API_URL}/api/physiciansinstitute`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setUserinstData(response.data)
        //////////////////////////////console.log(response.data)
      })
      .catch((error) => {
        console.error("Error fetching user data:", error);

      });
  }, []);

  useEffect(() => {
    axios
      .get(`${API_URL}/api/adress`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setAdress(response.data)
        // ////////////////////////////////console.log(response.data)
      })
      .catch((error) => {
        console.error("Error fetching user data:", error);

      });
  }, []);

  useEffect(() => {
    axios
      .get(`${API_URL}/api/adressinstitutions`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setAdressinst(response.data)
        // ////////////////////////////////console.log(response.data)
      })
      .catch((error) => {
        console.error("Error fetching user data:", error);

      });
  }, []);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchQuery1);
    }, 500); // Așteaptă 500ms după ultima tastare

    return () => clearTimeout(handler); // Curăță timeout-ul la fiecare tastare
  }, [searchQuery1]);

  useEffect(() => {
    if (debouncedSearch) {
      fetchSearchData(debouncedSearch, currentPage);
    } else {
      fetchData();
    }
  }, [debouncedSearch, currentPage]);

  const [sortConfig, setSortConfig] = useState({
    key: 'user_name_surname', // Initial sorting key
    direction: 'ascending',   // Initial sorting direction
  });

  const sortedData = [...filteruserData].sort((a, b) => {
    if (sortConfig.key && a[sortConfig.key] !== undefined && b[sortConfig.key] !== undefined) {
      const aValue = a[sortConfig.key];
      const bValue = b[sortConfig.key];

      if (typeof aValue === "string" && typeof bValue === "string") {
        return sortConfig.direction === "ascending"
          ? aValue.localeCompare(bValue)
          : bValue.localeCompare(aValue);
      } else if (typeof aValue === "number" && typeof bValue === "number") {
        return sortConfig.direction === "ascending" ? aValue - bValue : bValue - aValue;
      } else if (sortConfig.key === "created_timestamp") {
        return sortConfig.direction === "ascending"
          ? new Date(aValue) - new Date(bValue)
          : new Date(bValue) - new Date(aValue);
      }
    }
    return 0;
  });

  const handleEditRows = (item) => {
    logAuditUI({
      actionType: 'OPEN_FORM',
      module: 'Doctori',
      entityType: 'physician',
      entityId: item?.physician_id,
      entityName: item?.user_name_surname,
      description: `A deschis pagina de editare a medicului "${item?.user_name_surname}"`,
      routePath: '/physicians/editphysician',
    });
    navigate("/physicians/editphysician", { state: { item } });
  };

  const total = userData.filter((user) => {
    return (
      user.user_name_surname.toLowerCase().includes(searchQuery1.toLowerCase()) ||
      user.description?.toLowerCase().includes(searchQuery1.toLowerCase()) ||
      user.district_name?.toLowerCase().includes(searchQuery1.toLowerCase()) ||
      user.inst?.toLowerCase().includes(searchQuery1.toLowerCase())
    );
  });

  const totalPages = Math.ceil(total.length / itemsPerPage);

  const handleNewRows = (item) => {
    //////////////////////////////console.log(item);
    logAuditUI({
      actionType: 'OPEN_FORM',
      module: 'Doctori',
      description: 'A deschis formularul de creare medic nou',
      routePath: '/physicians/createphysician',
    });
    navigate("/physicians/createphysician");
  };

  const nextPage = () => {
    setCurrentPage(prevPage => {
      const newPage = prevPage + 1;
      return newPage;
    });
  };

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => {
        const newPage = prevPage - 1;
        return newPage;
      });
    }
  };
  const scrollRef = useRef(null);

  // Salvează scroll-ul în localStorage
  const handleScroll = useCallback(() => {
    if (scrollRef.current) {
      const scrollTop = scrollRef.current.scrollTop;
      localStorage.setItem('tableScrollPos', scrollTop.toString());
    }
  }, []);

  useEffect(() => {
    if (sortedData.length && scrollRef.current) {
      const savedScroll = localStorage.getItem('tableScrollPos');
      if (savedScroll) {
        scrollRef.current.scrollTop = parseInt(savedScroll, 10);
      }
    }
  }, [sortedData]);


  useEffect(() => {
    const div = scrollRef.current;

    const savedScroll = localStorage.getItem('tableScrollPos');
    if (savedScroll && div) {
      const scrollTop = parseInt(savedScroll, 10);
      const interval = setInterval(() => {
        if (div.scrollHeight > scrollTop) {
          div.scrollTop = scrollTop;
          clearInterval(interval);
        }
      }, 50);
    }

    if (div) {
      div.addEventListener('scroll', handleScroll);
    }

    return () => {
      if (div) {
        div.removeEventListener('scroll', handleScroll);
      }
    };
  }, [handleScroll]);

  return (
    <>
      {showGrid ? (
        <div className="flex flex-row gap-2">
          <div className="animate-pulse bg-gray-300 w-14 h-14 rounded-lg"></div>
          <div className="flex flex-col gap-2">
            <div className="animate-pulse bg-gray-300 w-28 h-5 rounded-lg"></div>
            <div className="animate-pulse bg-gray-300 w-36 h-3 rounded-lg"></div>
            <div className="animate-pulse bg-gray-300 w-36 h-2 rounded-lg"></div>
          </div>
        </div>
      ) : (
        <>
          <div className="col-span-full xl:col-span-12 bg-white dark:bg-gray-800 shadow-sm rounded-xl justify-center items-center">
            <header className="px-5 py-4 border-b border-gray-100 dark:border-gray-700/60 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2 sm:gap-0">

              {/* Left: Title */}
              <div className="relative mb-4 sm:mb-0">
                <h1 className="text-2xl md:text-3xl text-gray-800 dark:text-gray-100 font-bold">Doctori</h1>
              </div>

              {/* Right: Search input and button */}
              <div className="sm:flex sm:items-center sm:gap-4 w-full sm:w-auto">

                {/* Search input */}
                <div className="relative w-full sm:w-64 md:w-80">
                  <BsSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                  <input
                    type="text"
                    className="pl-10 w-full rounded-md border border-gray-300 bg-white px-3 py-2 focus:border-blue-500 focus:outline-none dark:bg-gray-800 dark:text-gray-200"
                    placeholder="Căutare"
                    value={searchQuery1}
                    onChange={(e) => setSearchQuery1(e.target.value)} />
                </div>

                {/* Add view button */}
                {user && user.role === 'Admin' && (

                <button className="btn bg-gray-900 text-gray-100 hover:bg-gray-800 dark:bg-gray-100 dark:text-gray-800 dark:hover:bg-white mt-4 sm:mt-0" onClick={handleNewRows}>
                  <svg className="fill-current shrink-0 xs:hidden" width="16" height="16" viewBox="0 0 16 16">
                    <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
                  </svg>
                  <span className="//max-xs:sr-only">Adauga Doctor</span>
                </button>
                )}
              </div>
            </header>

            <div className="p-2 flex justify-center items-center h-full w-full"> {/* Adăugat flex, justify-center, items-center */}
              <div ref={scrollRef}
                onScroll={handleScroll}
                className="overflow-x-auto w-full max-w-10xl max-h-[70vh]"> {/* max-width pentru a limita lățimea */}

                <table className="table-auto w-full">
                  {/* Table header */}
                  <thead className="text-xs font-semibold uppercase text-gray-700 dark:text-white bg-gray-100 dark:bg-gray-800">
                    <tr>
                      <th
                        className="p-3 whitespace-nowrap cursor-pointer"
                        role="button"
                        onClick={() => setSortConfig((prevConfig) => ({
                          key: "user_name_surname",
                          direction: prevConfig.key === "user_name_surname" && prevConfig.direction === "ascending"
                            ? "descending"
                            : "ascending",
                        }))}
                      >
                        <div className="flex items-center gap-2">
                          Name
                          {sortConfig.key === "user_name_surname" && (
                            <span>{sortConfig.direction === "ascending" ? "▲" : "▼"}</span>
                          )}
                        </div>
                      </th>
                      <th
                        className="p-3 whitespace-nowrap cursor-pointer"
                      >
                        <div className="flex items-center gap-2">
                          Specialitatea
                        </div>
                      </th>

                      {/* <th
                        className="p-3 whitespace-nowrap cursor-pointer"
                      >
                        <div className="flex items-center gap-2">
                          Institutia
                        </div>
                      </th> */}
                      {/* <th
                        className="p-3 whitespace-nowrap cursor-pointer"
                      >
                        <div className="flex items-center gap-2">
                          oras - sat
                        </div>
                      </th> */}
                      <th className="p-3 whitespace-nowrap cursor-pointer hidden md:table-cell">
                        <div className="flex items-center gap-2">
                          Acord date
                        </div>
                      </th>
                      <th className="p-3 whitespace-nowrap cursor-pointer hidden md:table-cell">
                        <div className="flex items-center gap-2">
                          Status
                        </div>
                      </th>
                    </tr>
                  </thead>
                  {/* Table body */}
                  <tbody className="text-sm divide-y divide-gray-100 dark:divide-gray-700/60">
                    {[...new Map(sortedData.map(item => [item.physician_id, item])).values()]
                      .map((customer, index) => {
                        const institutionIds = userinstData
                          .filter((i) => i.physician_id === customer.physician_id)
                          .map((i) => i.speciality_id);
                        const filteredAdress = specData.filter((i) =>
                          institutionIds.includes(i.speciality_id)
                        );
                        const isSelected = selectedInstitutionId === customer.physician_id;

                        return (
                          <React.Fragment key={customer.physician_id}>
                            {/* Rând principal */}
                            <tr
                              role="button"
                              className={`${index % 2 === 0 ? "bg-gray-0 dark:bg-gray-800" : "bg-gray-100 dark:bg-gray-700"} hover:bg-gray-200 dark:hover:bg-gray-600`}
                            >
                              <td className="p-2 whitespace-nowrap xs:text-wrap"
                                onClick={() => {
                                  handleEditRows(customer);
                                }}>
                                <div className="text-left">{customer.user_name_surname}</div>
                              </td>
                              <td className="p-2 whitespace-nowrap">
                                <div className="text-left">
                                  {filteredAdress.length >= 1 ? (
                                    <button
                                      className="text-blue-500 underline"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        setSelectedInstitutionId(isSelected ? null : customer.physician_id);
                                        // setSelectedInstitutionId1(null);
                                      }}
                                    >
                                      Vezi toate specialitățile ({filteredAdress.length})
                                    </button>
                                  ) : (
                                    <span>Fara date</span>
                                  )}
                                </div>
                              </td>
                              <td className="p-2 whitespace-nowrap hidden md:table-cell"
                                onClick={() => {
                                  handleEditRows(customer);
                                }}
                              >
                                <div className={`text-left font-medium  ${customer.data_acord ? 'text-green-500' : 'text-red-500'}`}>
                                  {customer.data_acord ? "Afirmativ" : "Negativ"}
                                </div>
                              </td>
                              <td className="p-2 whitespace-nowrap hidden md:table-cell"
                                onClick={() => {
                                  handleEditRows(customer);
                                }}
                              >
                                <div className={`text-left font-medium ${customer.is_active ? 'text-green-500' : 'text-red-500'}`}>
                                  {customer.is_active ? "Activ" : "Inactiv"}
                                </div>
                              </td>
                            </tr>

                            {isSelected && (
                              <tr className="bg-gray-50 dark:bg-gray-800">
                                <td colSpan="7" className="p-2">
                                  <table className="w-full border border-gray-300 dark:border-gray-600">
                                    <thead className="text-xs uppercase text-gray-500 dark:text-gray-500 bg-gray-100 dark:bg-gray-700 dark:bg-opacity-50 rounded-sm">
                                      <tr>
                                        <th className="p-2">
                                          <div className="font-semibold text-left">Specialitatea</div>
                                        </th>
                                        <th className="p-2">
                                          <div className="font-semibold text-left">Institutia</div>
                                        </th>
                                        <th className="p-2">
                                          <div className="font-semibold text-left hidden md:table-cell">Adresa</div>
                                        </th>
                                        <th className="p-2">
                                          <div className="font-semibold text-left hidden md:table-cell">Oras</div>
                                        </th>
                                        <th className="p-2">
                                          <div className="font-semibold text-left hidden md:table-cell">Regiunea</div>
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {filteredAdress.map((item, idx) => {
                                        // Determinăm datele pentru fiecare rând
                                        const matchingInstCity1 = userinstData
                                          .filter((i) => i.speciality_id === item.speciality_id && i.physician_id === customer.physician_id)
                                          .map((i) => i.institution_in_adress_id);

                                        const matchdistrict = Adressinst
                                          .filter((i) => matchingInstCity1.includes(i.id))
                                          .map((i) => i.adress_id);

                                        const matchingCity1 = matchdistrict.length > 0
                                          ? Adress.find((i) => matchdistrict.includes(i.adress_id))
                                          : null;

                                        return (
                                          <tr key={idx} className="border border-gray-300 dark:border-gray-600">
                                            <td className="p-2 text-left">{item.description}</td>
                                            <td className="p-2 whitespace-nowrap">
                                              <div className="text-left">
                                                {userinstData.find(
                                                  (i) => i.speciality_id === item.speciality_id && i.physician_id === customer.physician_id
                                                )?.inst || "-"}
                                              </div>
                                            </td>
                                            <td className="p-2 whitespace-nowrap hidden md:table-cell">
                                              <div className="text-left">
                                                {matchingCity1 ? matchingCity1.description : "-"}
                                              </div>
                                            </td>
                                            <td className="p-2 whitespace-nowrap hidden md:table-cell">
                                              <div className="text-left">
                                                {matchingCity1 ? matchingCity1.city_name : "-"}
                                              </div>
                                            </td>
                                            <td className="p-2 whitespace-nowrap hidden md:table-cell">
                                              <div className="text-left">
                                                {matchingCity1 ? matchingCity1.district_name : "-"}
                                              </div>
                                            </td>
                                          </tr>
                                        );
                                      })}
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                            )}

                          </React.Fragment>
                        );
                      })}
                  </tbody>
                </table>
              </div>

            </div>

            <div className="flex justify-center mt-4 mb-4">
              <button
                onClick={prevPage}
                className="px-4 py-2 bg-gray-200 dark:bg-gray-700 text-sm font-medium rounded-l-md hover:bg-gray-300 dark:hover:bg-gray-600 disabled:opacity-50"
                disabled={currentPage === 1}
              >
                Prev
              </button>

              {currentPage > 3 && (
                <>
                  <button
                    onClick={() => setCurrentPage(1)}
                    className="px-4 py-2 text-sm font-medium bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600"
                  >
                    1
                  </button>
                  <span className="px-2">...</span>
                </>
              )}

              {Array.from({ length: totalPages }, (_, index) => {
                const page = index + 1;

                if (
                  page === currentPage ||
                  // page === 1 ||
                  // page === totalPages ||
                  (page >= currentPage - 2 && page <= currentPage + 2)
                ) {
                  return (
                    <button
                      key={page}
                      onClick={() => setCurrentPage(page)}
                      className={`px-4 py-2 text-sm font-medium ${currentPage === page
                        ? "bg-gray-500 text-white"
                        : "bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600"
                        }`}
                    >
                      {page}
                    </button>
                  );
                }
                return null;
              })}

              {currentPage < totalPages - 2 && (
                <>
                  <span className="px-2">...</span>
                  <button
                    onClick={() => setCurrentPage(totalPages)}
                    className="px-4 py-2 text-sm font-medium bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600"
                  >
                    {totalPages}
                  </button>
                </>
              )}

              <button
                onClick={nextPage}
                className="px-4 py-2 bg-gray-200 dark:bg-gray-700 text-sm font-medium rounded-r-md hover:bg-gray-300 dark:hover:bg-gray-600 disabled:opacity-50"
                disabled={currentPage === totalPages}
              >
                Next
              </button>
            </div>
          </div></>
      )}</>
  );
}
export default DashboardCard21;